import UpdatePass from './Modal/UpdatePass'
import UpdateBalanceModal from './Modal/UpdateBalanceModal'
import {useUserListProvider} from './UserListProvider'
import TableContent from '../../utils/components/Table/TableContent'
import TablePagination from '../../utils/components/Table/TablePagination'
import {UserListColumn} from './UserColumn'
import {KTIcon} from '../../../_metronic/helpers'
import UserFilter from './UserFilter'
import {UserListSelectContext, useUserListSelectProvider} from './UserListSelectProvider'
import SelectList from '../PaymentRequest/SelectList'
import {Helmet} from 'react-helmet-async'
import InputSearchBox from '../../utils/components/form/InputSearchBox'
import DebounceSearchBox from '../../utils/components/form/DebounceSearchBox'

const UserList = () => {
  const {
    isLoading,
    users: users,
    totalElement,
    itemsPerPage,
    currentPage,
    handlePageChange,
    downloadFile,
    searchTerm,
    setSearchTerm,
  } = useUserListProvider()

  const {selected} = useUserListSelectProvider()

  return (
    <div>
      <Helmet>
        <title>Users</title>
      </Helmet>
      <div className='d-flex justify-content-between align-items-center mb-4 gap-4 flex-wrap'>
        <div className=''>
          <DebounceSearchBox
            placeholder='Search by username, email, phone'
            onSearch={(value) => setSearchTerm(value)}
            searchDelay={500}
          />
        </div>

        <div className='card-title m-0'>
          {selected.length > 0 ? (
            <SelectList context={UserListSelectContext} />
          ) : (
            <>
              <UserFilter />

              <button type='button' className='btn btn-success' onClick={downloadFile}>
                <KTIcon iconName='exit-up' className='fs-2' />
                Export
              </button>
            </>
          )}
        </div>
      </div>

      <div className='card'>
        {/* <Row className='mt-8'>         
          <Col className='d-flex justify-content-end align-items-end'>
            <div className='fs-6 bg-secondary rounded px-6 py-3'>
              <p className='d-inline'>
                Client:
                <span className='fw-bold'> {counts.client}</span>
              </p>
              <p className='d-inline'>
                {' '}
                Reseller:
                <span className='fw-bold'> {counts.reseller}</span>
              </p>
              <p className='d-inline'>
                {' '}
                Unknown:
                <span className='fw-bold'> {counts.unknown}</span>
              </p>
            </div>
          </Col>
        </Row> */}

        <TableContent isLoading={isLoading} tableData={users} tableColumn={UserListColumn}>
          <TablePagination
            totalElement={totalElement}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
          />
        </TableContent>
      </div>

      <UpdatePass />
      <UpdateBalanceModal />
    </div>
  )
}

export default UserList
